import React from 'react';
import { formatDisplay } from 'helpers/formatHelper';
// @ts-expect-error [TS migration] Was not detected by flow
import { Textfit } from 'react-textfit';
import { getDecimalPrecision } from 'helpers/chart/settings';
import { GraphProps } from '../types';

export default function NumberChart(props: GraphProps): React.ReactElement {
    const { data, settings } = props;
    const yColumn = props.orderedColumns.y;
    // TODO [typing getData hooks] try to remove this non-null assertion
    if (data.length === 0 || data[0][yColumn.key]!.toString() === 'unknown') {
        return <div className="chart-card-message">Aucune donnée</div>;
    }
    // @ts-expect-error [TS migration] Was not detected by flow
    const value = parseFloat(data[0][yColumn.key]);
    return (
        <div
            className="number-chart"
            onClick={() => props.onClick(data[0])}
            role="button"
            tabIndex={0}
        >
            <Textfit mode="single" forceSingleModeWidth={false}>
                <h1>
                    {formatDisplay(
                        value,
                        yColumn.type,
                        getDecimalPrecision(settings),
                        settings.displayBy,
                    )}
                </h1>
            </Textfit>
            <Textfit mode="single" forceSingleModeWidth={false}>
                <h2>
                    {settings.numberText ? settings.numberText : yColumn.label}
                </h2>
            </Textfit>
        </div>
    );
}
